/**
 * FeatureLocked — placeholder shared para páginas que exigem uma capability
 * que o user atual não tem. Copy funcional sem cap-code (jargão dev fica em
 * `data-capability`, inspecionável para diagnóstico; admin resolve via
 * Configurações → Pacote / Add-on).
 */
export function FeatureLocked({ capability }: { capability: string }): JSX.Element {
  return (
    <div
      className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center"
      data-capability={capability}
    >
      <div className="max-w-md rounded-2xl border border-border-subtle bg-surface p-8">
        <span className="text-5xl">🔒</span>
        <h2 className="mt-4 text-lg font-semibold text-text-primary">
          Seu perfil não tem acesso a esta área
        </h2>
        <p className="mt-2 text-sm text-text-secondary">
          Peça ao administrador do tenant para liberar o acesso (Configurações → Pacote).
        </p>
      </div>
    </div>
  );
}
